/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useState, useEffect } from 'react'
import { toast } from 'react-toastify'
import { Col, Dropdown, Modal, Row, Spinner, Form, Pagination, Table, Button } from 'react-bootstrap'

// Components
import ImageWrapper from 'CoP/components/app/ImageWrapper'

// Hooks
import useServices from 'utils/hooks/useServices'
import useDebounce from 'utils/hooks/useDebounce'
import usePagination from 'utils/hooks/usePagination'

// Helpers
import FormGenerator from 'utils/helpers/FormGenerator'

// API Service...
import MasterServices from 'services/master'

// Layouts...
import { PageTitle } from '_metronic/layout/core'

// Initial..
const heads = [
    {
        name: '',
        label: 'Cover (Thumbnail)',
    },
    {
        name: '',
        label: 'Youtube ID',
    },
    {
        name: '',
        label: 'Status',
    },
    {
        name: '',
        label: 'Aksi',
    },
]

const inputs = [
    {
        name: 'upload_thumbnail',
        label: 'Upload Thumbnail',
        type: 'file',
        validation: {},
        col: 12,
        options: [],
        additional: '',
        // additional option for file type
        accept: 'image/*',
    },
    {
        name: 'link_youtube',
        label: 'Youtube ID',
        type: '',
        validation: {},
        col: 12,
        options: [],
        additional: '',
    },
    {
        name: 'judul',
        label: 'Judul',
        type: '',
        validation: {},
        col: 12,
        options: [],
        additional: '',
    },
    {
        name: 'deskripsi',
        label: 'Deskripsi',
        type: 'rich-text',
        validation: {},
        col: 12,
        options: [],
        additional: '',
    },
    {
        name: 'is_active',
        label: 'Status',
        type: 'select',
        validation: {},
        col: 12,
        options: [
            {
                name: '',
                value: '',
            },
            {
                name: 'Aktif',
                value: '1',
            },
            {
                name: 'Non-Aktif',
                value: '0',
            },
        ],
        getItemValue: 'name',
        getItemValueId: 'value',
        additional: '',
    },
]

const COPVideoPage: FC = () => {
    const { Header, Body, Footer, Title } = Modal
    const { Control, Select } = Form
    const { Toggle, Menu, Item } = Dropdown
    const { Item: PaginationItem } = Pagination

    const [pagination, setPagination] = useState({
        per_page: 10,
        page: 1,
        total_page: 1,
        total_page_arr: [1, 2, 3, 4, 5],
        total_row: 10,
    })
    const [isEdit, setIsEdit] = useState(false)
    const [show, setShow] = useState(false)
    const [query, setQuery] = useState<any>({q: '', sort_order: 'desc'})
    const [formValue, setFormValue] = useState<any>({})
    const [submit, setSubmit] = useState(false)
    const [data, loading, empty, refresh, isError, setLoading] = useServices(
        MasterServices.getCOPVideos,
        {...query, page: pagination.page, sort_field: 'created_at', per_page: pagination.per_page},
        []
    )

    const paginator: any = usePagination({
        totalCount: data?.data?.total,
        pageSize: pagination.per_page || 10,
        currentPage: pagination.page || 1,
    })

    useEffect(() => {
        refresh()
        generateTotalPage(pagination.total_page)
    }, [pagination.per_page, pagination.page])
    
    useDebounce(refresh, 250, [query.q, query.sort_order])

    const toggle = () => {
        if (show) {
            setFormValue({})
        }
        
        setShow(!show)
    }
    
    const generateTotalPage = (totalPage: number) => {
        let total = 0
        let newTotal: any = []

        for (total = 0; total < totalPage; total++) {
            if (total < 4) {
                newTotal.push(total + 1)
            } else if (total === 8) {
                newTotal.push('...')
                newTotal.push(totalPage)
            }
        }
        return newTotal
    }
    
    const onChangePerPage = (per_page: number, to_page = 1) => {
        setPagination({
            ...pagination,
            per_page: per_page,
            page: to_page || 1,
        })
    }
    
    const onChange = (e: any) => {
        const {name, value} = e.target
        setFormValue({
            ...formValue,
            [name]: value,
        })
    }
    
    // const handleDelete = async (id: any) => {
    //     try {
    //         if (window.confirm('Yakin ingin menghapus Video COP?')) {
    //             setLoading(true)
    //             await MasterServices.deleteCOPVideo(id)
    //             toast.success(`Video Berhasil Dihapus`)
    //             refresh()
    //         }
    //     } catch (error) {
    //     }
    // }
    
    const onSubmit = async (e: any) => {
        e.preventDefault()

        try {
            setSubmit(true)

            const formData = new FormData()

            if (formValue.is_active === undefined) {
                formValue.is_active = '0'
            }

            const id = formValue.id

            // Add all form values to FormData
            Object.keys(formValue).forEach(key => {
                if (key === 'id') {
                    // Don't include id in formData
                    return;
                } else if (key === 'upload_thumbnail') {
                    // Check if upload_thumbnail is a File object
                    if (formValue[key] instanceof File) {
                        // It's a file, add it to formData
                        formData.append(key, formValue[key]);
                    } else if (typeof formValue[key] === 'string' && formValue[key].trim() !== '') {
                        // It's a string URL from an existing record - skip it
                        return
                    } else {
                        // Empty or null value
                        formData.append(key, '')
                    }
                } else {
                    formData.append(key, formValue[key])
                }
            })

            if (id) {
                await MasterServices.updateCOPVideo(id, formData)
            } else {
                await MasterServices.storeCOPVideo(formData)
            }

            toast.success(`Berhasil ${id ? 'Memperbarui' : 'Membuat'} Video`)
            toggle()
            refresh()
        } catch (error) {
            console.error(error)
        } finally {
            setSubmit(false)
        }
    }

    return (
        <div className='row'>
            <Modal show={show} onHide={toggle} size='lg'>
                <Header closeButton>
                    <Title>{isEdit ? 'Form' : 'Form'} Video</Title>
                </Header>
                <Form onSubmit={onSubmit}>
                    <Body>
                        <Row>{FormGenerator(inputs, formValue, onChange)}</Row>
                    </Body>
                    <Footer>
                        <Button variant='secondary' onClick={toggle} disabled={submit}>
                            Batalkan
                        </Button>
                        <Button variant='primary' type='submit' disabled={submit}>
                            {submit ? 'Loading' : 'Simpan'}
                        </Button>
                    </Footer>
                </Form>
            </Modal>

            <div className='col-md-12'>
                <div className='card-custom' style={{paddingBottom: '80px'}}>
                    <Row>
                        <Col md={{span: 4}}>
                            <Control
                                placeholder='Cari...'
                                name='q'
                                onChange={(e) => setQuery({...query, q: e.target.value})}
                            />
                        </Col>
                        <Col md={{span: 2, offset: 4}}>
                            <Button
                                type='button'
                                onClick={() => {
                                    setFormValue({})
                                    toggle()
                                }}
                                className='form-control'
                            >
                                {'  '}+ Tambah
                            </Button>
                        </Col>
                        <Col md={{span: 2}}>
                            <Select
                                aria-label='Default select example'
                                className='mr-8'
                                onChange={(e) => {
                                    setQuery({...query, sort_order: e.target.value})
                                }}
                            >
                                <option value='desc'>Terbaru</option>
                                <option value='asc'>Terlama</option>
                            </Select>
                        </Col>
                    </Row>{' '}
                    <Row md={12} className='mt-8'>
                        <Table responsive className='table-striped align-middle'>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    {heads.map((item, index) => (
                                        <th key={index} style={{maxWidth: item.label == 'Aksi' ? '100px' : ''}}>
                                            {item.label}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {data.data?.data?.length === 0 && !loading && (
                                    <tr>
                                    <td colSpan={5} align='center'>
                                        Tidak ada Data
                                    </td>
                                    </tr>
                                )}

                                {loading ? (
                                    <tr>
                                        <td colSpan={5} align='center'>
                                            <Spinner
                                                animation='border'
                                                role='status'
                                                style={{height: '100px', width: '100px'}}
                                            />
                                        </td>
                                    </tr>
                                ) : (
                                    data.data?.data?.map((item: any, key: any) => {
                                        return (
                                            <tr key={key}>
                                                <td>{key + 1}</td>
                                                <td>
                                                    <ImageWrapper src={item.upload_thumbnail} alt='Thumbnail Preview' />
                                                </td>
                                                <td>{item.link_youtube || '-'}</td>
                                                <td>
                                                    {item.is_active == '0' ? (
                                                        <Button
                                                            variant='secondary'
                                                            className='shadow-none btn-sm btn-sm btn-outline btn-outline-dark'
                                                        >
                                                            Non-Aktif
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            className='shadow-none btn btn-sm btn-outline btn-outline-success'
                                                            variant='outline'
                                                        >
                                                            Aktif
                                                        </Button>
                                                    )}
                                                </td>
                                                <td>
                                                    <Button
                                                        onClick={() => {
                                                            setFormValue({
                                                                id: item.id,
                                                                upload_thumbnail: item.upload_thumbnail,
                                                                link_youtube: item.link_youtube,
                                                                judul: item.judul,
                                                                deskripsi: item.deskripsi,
                                                                is_active: item.is_active,
                                                            })
                                                            toggle()
                                                        }}
                                                        className='btn-sm'
                                                    >
                                                        Edit
                                                    </Button>
                                                </td>
                                            </tr>
                                        )
                                    })
                                )}
                            </tbody>
                        </Table>
                    </Row>
                    <Row>
                        <Col md={6}>
                            {data?.data?.data?.length > 0 && !loading && (
                            <div style={{float: 'left'}}>
                                <Dropdown>
                                    <Toggle className='btn btn-sm'>
                                        {pagination.per_page}
                                    </Toggle>
                                    <Menu>
                                        {[10, 25, 50, 100].map((item: any) => (
                                        <Item
                                            key={item}
                                            href='#/action-1'
                                            onClick={() => onChangePerPage(item)}
                                            disabled={pagination.per_page === item}
                                        >
                                            {item}
                                        </Item>
                                        ))}
                                    </Menu>
                                </Dropdown>
                            </div>
                            )}
                        </Col>
                        <Col md={6}>
                            <div style={{float: 'right'}}>
                                {!loading && (
                                    <Pagination className='btn-sm'>
                                        {paginator?.map((item: any) => {
                                            return (
                                            <PaginationItem
                                                className='btn-sm'
                                                key={item}
                                                active={item === pagination.page}
                                                onClick={() => onChangePerPage(pagination.per_page, item)}
                                                disabled={item === '...'}
                                            >
                                                {item}
                                            </PaginationItem>
                                            )
                                        })}
                                    </Pagination>
                                )}
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
}

const COPVideo: FC = () => (
    <>
        <PageTitle
            breadcrumbs={[
                {
                    title: 'CoP',
                    path: '/cop-dashboard',
                    isSeparator: false,
                    isActive: false,
                },
                {
                    title: '/',
                    path: '',
                    isSeparator: false,
                    isActive: false,
                },
            ]}
        >
            Video (Youtube)
        </PageTitle>
        <COPVideoPage />
    </>
)

export default COPVideo